var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-foot"},[_c('div',[_vm._v("Copy Right Coin Switch Technology")]),_c('div',[_vm._v("All rights reserved")]),_c('div',[_vm._v("© 2017–2023")])])
}]

export { render, staticRenderFns }